export const translations = {
  DELIVERY_IMPORT: 'Upload delivery details',
  LOADING_IMPORT: 'Upload loading details',
  FREIGHT_IMPORT: 'Upload freight details',
  MASTER_IMPORT: 'Upload master details',
  START_IMPORT: 'Start import',
  APP_TITLE: 'Data uploader | Jules AI',
  LOGISTIC_FORWARDER: 'Select logistic forwarder',
  LOGISTIC_FORWARDER_NAME: 'Logistic forwarder',
  SHIPPING_LINE_NAME: 'Shipping line',
  LOADING_UNIT: 'Volume unit & loading type',
  DELIVERY_UNIT: 'Volume unit & delivery type',
  GO: 'Go',
  GO_BACK: 'Go back',
  IMPORT_DATA: 'Import data',
  IMPORT_DELIVERIES: 'Import deliveries',
  IMPORT_LOADINGS: 'Import loadings',
  CHECKOUT_DELIVERIES_ON_APP: 'Check deliveries on the web application',
  CHECKOUT_LOADINGS_ON_APP: 'Check loadings on web application',
  POPUP_VALIDATION: 'Required',
  POPUP_LOADING_VALIDATION: 'All fields are mandatory',
  LOADING_TYPE: 'Select loading type',
  DELIVERY_TYPE: 'Select delivery type',
  VALIDITY_MONTH: 'Select validity month',
  LOGISTIC_MATERIAL: 'Select logistic material',
  QUALITY_GROUP: 'Select quality group',
  INCO_TERMS: 'Select incoterm',
  LOGISTIC_FORWARDER_SHIPPING_LINE: 'Select value',
  FREIGHT_POPUP: 'Select below details',
  INVALID_CREDENTIALS: 'Your email and/or password are incorrects',
  VALID_CREDENTIALS: 'Login successfull',
  SAMPLE_TEMPLATE: 'Download template',
  SUPPORT_HELP: 'Support',
  CONTRACT_IMPORT: 'Renew contract details',
  CONTRACT: 'Renew contract',
  CONFIRMATION_TEXT: 'Are you sure you want to renew the records?',
  CONFIRMATION_YES: 'Yes',
  CONFIRMATION_NO: 'No',
  RENEW: 'Renew',
  RENEWING_TEXT: 'Renewing the records',
  FROM: 'from',
  TO: 'to',
  LOADINGS_HEADER: 'Loadings',
  DELIVERIES_HEADER: 'Deliveries',
  FREIGHT_HEADER: 'Freight',
  MASTER_HEADER: 'Master import',
  CONTRACT_RENEWAL_HEADER: 'Contract Renewal',
  LOGOUT: 'Logout',
  VOLUME_UNIT: 'Select volume unit',
  MATERIAL: 'Material',
  ITEM: 'Item',
  LOADING_TEXT: 'Please wait',
  'The commodity or material name': 'The commodity or material name',
  'The material name cannot be blank': 'The material name cannot be blank',
  'Net Weight': 'Net Weight',
  'Quantity of material in delivery': 'Quantity of material in delivery',
  'Quantity cannot be left blank': 'Quantity cannot be left blank',
  'Date of delivery': 'Date of delivery',
  'Date of delivery cannot be left blank':
    'Date of delivery cannot be left blank',
  'Reference number': 'Plate number',
  'Container reference number': 'Container reference number',
  'ERP Container id': 'ERP Container id',
  'Gross Weight': 'Gross Weight',
  'Maximum Gross Weight': 'Maximum Gross Weight',
  'General comment': 'General comment',
  'Loading comment': 'Loading comment',
  'Delivery comment': 'Delivery comment',
  'Tare Weight': 'Tare Weight',
  'Packages': 'Packages',
  'Quantity in tons': 'Quantity in tons',
  'Quantity converted to tons': 'Quantity converted to tons',
  'Quality id': 'Quality id',
  'The id linked to the quality name': 'The id linked to the quality name',
  'Container id': 'Container id',
  'The truck plate number or container reference number':
    'The truck plate number or container reference number',
  'Jules number': 'Jules number',
  'CT number for the truck or container':
    'CT number for the truck or container',
  'Other delivery number': 'Other delivery number',
  'Any other delivery reference number': 'Any other delivery reference number',
  'Buy operation id': 'Buy operation id',
  'Sell operation id': 'Sell operation id',
  'Container operation quality id': 'Container operation quality id',
  'Unit (qty)': 'Unit (qty)',
  'Seal number': 'Seal number',
  'Container seal number': 'Container seal number',
  'Thickness': 'Thickness',
  'Unit (thickness)': 'Unit (thickness)',
  'Length': 'Length',
  'Unit (length)': 'Unit (length)',
  'Width': 'Width',
  'Unit (width)': 'Unit (width)',
  'Height': 'Height',
  'Unit (height)': 'Unit (height)',
  'Unit (dimensions)': 'Unit (dimensions)',
  'User delivery type': 'User delivery type',
  'Package Reference': 'Package Reference',
  'Delivery tare weight quantity': 'Delivery tare weight quantity',
  'Delivery tare weight cannot be left blank':
    'Delivery tare weight cannot be left blank',
  'Delivery tare weight volume': 'Delivery tare weight volume',
  'Delivery tare volume cannot be left blank':
    'Delivery tare volume cannot be left blank',
  'Height cannot be left blank': 'Height cannot be left blank',
  'Height unit cannot be left blank': 'Height unit cannot be left blank',
  'Dimension unit cannot be left blank': 'Dimension unit cannot be left blank',
  'Thickness cannot be left blank': 'Thickness cannot be left blank',
  'Thickness unit cannot be left blank': 'Thickness unit cannot be left blank',
  // eslint-disable-next-line max-len

  'If you press the \"Go back\" button, you will lose the progress of the current step.':
    'If you press the \"Go back\" button, you will lose the progress of the current step.',
  'If you press the \"Go back\" button, you will lose the entire progress of all steps.':
    'If you press the \"Go back\" button, you will lose the entire progress of all steps.',
  // eslint-disable-next-line max-len
  'Are you sure you want to submit your data? Rows with an error wont be imported. If yes, please use the “Submit” button. Otherwise, press the “Back” button':
    // eslint-disable-next-line max-len
    'Are you sure you want to submit your data? Rows with an error wont be imported. If yes, please use the “Submit” button. Otherwise, press the “Back” button',
  // eslint-disable-next-line max-len
  'Are you sure you want to submit your data? If yes, please use the “Submit” button. Otherwise, press the “Back” button':
    // eslint-disable-next-line max-len
    'Are you sure you want to submit your data? If yes, please use the “Submit” button. Otherwise, press the “Back” button',

  // eslint-disable-next-line max-len
  'Are you sure you want to submit your data? Rows with an error will be imported as well. If yes, please use the “Submit” button. Otherwise, press the “Back” button':
    // eslint-disable-next-line max-len
    'Are you sure you want to submit your data? Rows with an error will be imported as well. If yes, please use the “Submit” button. Otherwise, press the “Back” button',

  // eslint-disable-next-line max-len
  'Your import resulted in {{error}} errors. If you want to correct these errors inside the application, press the “Continue” button. Otherwise, you could download the merged table as Excel (.xlsx) by pressing the “Export as Excel” button.':
    // eslint-disable-next-line max-len
    'Your import resulted in {{error}} errors. If you want to correct these errors inside the application, press the “Continue” button. Otherwise, you could download the merged table as Excel (.xlsx) by pressing the “Export as Excel” button.',
  'Port of loading': 'Port of loading',
  'Port of loading should not be blank': 'Port of loading should not be blank',
  'Port of destination': 'Port of destination',
  'Port of destination should not be blank':
    'Port of destination should not be blank',
  'Shipping line': 'Shipping line',
  'Shipping line should not be left blank':
    'Shipping line should not be left blank',
  'Material group': 'Material group',
  'Material group should not be left blank':
    'Material group should not be left blank',
  'Cost': 'Cost',
  'Cost currency': 'Cost currency',
  'Comment': 'Comment',
  'Other cost': 'Other cost',
  'Other cost currency': 'Other cost currency',
  'BL cost': 'BL cost',
  'BL currency': 'BL currency',
  'Customs currency': 'Customs currency',
  'Freight cost': 'Freight cost',
  'Freight cost should not be left blank':
    'Freight cost should not be left blank',
  'Freight cost currency code': 'Freight cost currency code',
  'Logistic forwarder': 'Logistic forwarder',
  'Logistic material': 'Logistic material',
  'Incoterm': 'Incoterm',
  'Comment on freight': 'Comment on freight',
  'Last validity date': 'Last validity date',
  'First validity date': 'First validity date',
  'Cost volume': 'Cost volume',
  'Cost volume should not be left blank':
    'Cost volume should not be left blank',
  'BL cost value': 'BL cost value',
  'Currency code of BL cost': 'Currency code of BL cost',
  'Miscellaneous cost': 'Miscellaneous cost',
  'Currency code of THC admin cost': 'Currency code of THC admin cost',
  'Other cost volume': 'Other cost volume',
  'Other cost volume should not be left blank':
    'Other cost volume should not be left blank',
  'Customs cost': 'Customs cost',
  'Currency code of custom cost': 'Currency code of custom cost',
  'Select validity month': 'Select validity month',
  'Select logistic material': 'Select logistic material',
  'Select quality group': 'Select quality group',
  'Select incoterm': 'Select incoterm',
  'Check out freights on web app': 'Check out freights on web app',
  'Import Freight': 'Import Freight',
  'Date of loading': 'Date of loading',
  'Date of loading cannot be left blank': 'Date of loading cannot be left blank',
  'Container / Truck number': 'Container / Truck number',
  'MGW': 'MGW',
  'Weight unit': 'Weight unit',
  'Material ID': 'Material ID',
  'User loading type': 'User loading type',
  'ERP container ID': 'ERP container ID',
  'Transport Rate': 'Transport Rate',
  'Upload transport rate details': 'Upload transport rate details',
  'Select transport mode': 'Select transport mode',
  'Barge': 'Barge',
  'Rail': 'Rail',
  'Road': 'Road',
  'Select transport type': 'Select transport type',
  'Select material group': 'Select material group',
  'Check out transport rates on web app': 'Check out transport rates on web app',
  'Transport cost currency code': 'Transport cost currency code',
  'Carrier': 'Carrier',
  'Loading area': 'Loading area',
  'Destination area': 'Destination area',
  'Logistics': 'Logistics',
  'Import transport rate': 'Import transport rate',
  'Transport mode': 'Transport mode',
  'cost': 'cost',
  'Volumic customs cost': 'Volumic customs cost',
  'Volumic customs currency': 'Volumic customs currency',
  'Currency code of volumic customs': 'Currency code of volumic customs',
  'Volumic customs volume': 'Volumic customs volume',
  "Volumic customs volume shouldn't be left blank": "Volumic customs volume shouldn't be left blank",
  'Demurrage in days': 'Demurrage in days',
  'Detention in days': 'Detention in days',
  'Lane': 'Lane',
  'First validity date cannot be left blank': 'First validity date cannot be left blank',
  'Last validity date cannot be left blank': 'Last validity date cannot be left blank',
  "Cost volume shouldn't be left blank": "Cost volume shouldn't be left blank",
  "Transport currency shouldn't be left blank": "Transport currency shouldn't be left blank",
  "Select market type": "Select market type",
  "Transport All In Rate": "Transport All-in rates",
  'Upload transport all-in rate details': 'Upload transport all-in rate details',
  "Pre-carriage area": "Pre-carriage area",
  "Pre carriage volume": "Pre carriage volume",
  "Pre carriage cost": "Pre carriage cost",
  "Pre carriage currency": "Pre carriage currency",
  "Packing type": "Packing type",
  "Single container": "Single container",
  "Multiple container": "Multiple container",
  "UPLOAD_TYPE": "Select upload type",
  CONFIRMATION_TEXT_SAMPLE_DOC: 'If you found problem while opening file in excel please click on yes',
  CONFIRMATION_CONTINUE: 'Continue',
  CONFIRMATION_CANCEL: 'Cancel',
  "Select deviation type": "Select deviation type",
  "Sterile Weight": "Sterile Weight",
  "Sterile Gross Weight": "Sterile Gross Weight",
  "Pieces": "Pieces",
  "Upload container info": "Upload container info",
  "Delivery info": "Delivery info",
  "Loading info": "Loading info",
  "Logistic rates": "Logistic rates",
  "Export": "Export",
  "Local": "Local",
  "Upload transactional data details": "Upload transactional data details",
  "Transactional import": "Transactional import",
  "Select quality name": "Select quality name",
  "Volume unit, loading type & date of loading": 'Volume unit, loading type & date of loading',
  "Volume unit, loading type & date of delivery": 'Volume unit, loading type & date of delivery',
};